import RunStateBadge from "components/Run/elements/StateBadge";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { StackTaskRun } from "shared/Stack/useSearchTasks/gql";

const StackTasksTableStatusCell = ({
  item: task,
  ...cellProps
}: TableSimpleCellProps<StackTaskRun>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <RunStateBadge state={task.state} />
    </TableSimpleCell>
  );
};

export default StackTasksTableStatusCell;
